<template>
    <div class="row">
        <div class="col-8 text-center mx-auto mb-4">
            <p class="welcome-3 colortextmyfo1">{{ __('simulation.title') }}</p>

            <div class="row justify-content-center dashboardstyle">
                <table class="text-center py-0 px-4" style="margin:auto; width:100%;">
                    <thead class="" style="font-size: 14px; color: #3867D6; width:100%;">
                        <tr style="width:100%;">
                            <th class="pb-2" scope="col" style="width: 33.3%; vertical-align: middle;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-cash-stack svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M14 3H1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1h-1z"/><path fill-rule="evenodd" d="M15 5H1v8h14V5zM1 4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H1z"/><path d="M13 5a2 2 0 0 0 2 2V5h-2zM3 5a2 2 0 0 1-2 2V5h2zm10 8a2 2 0 0 1 2-2v2h-2zM3 13a2 2 0 0 0-2-2v2h2zm7-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"/></svg>Montant investi (€)</th>
                            <th class="pb-2" scope="col" style="width: 33.3%; vertical-align: middle;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-smartwatch svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M14 5h.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H14V5z"/><path fill-rule="evenodd" d="M8.5 4.5A.5.5 0 0 1 9 5v3.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1 0-1h2V5a.5.5 0 0 1 .5-.5z"/><path fill-rule="evenodd" d="M4.5 2h7A2.5 2.5 0 0 1 14 4.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 11.5v-7A2.5 2.5 0 0 1 4.5 2zm0 1A1.5 1.5 0 0 0 3 4.5v7A1.5 1.5 0 0 0 4.5 13h7a1.5 1.5 0 0 0 1.5-1.5v-7A1.5 1.5 0 0 0 11.5 3h-7z"/><path d="M4 2.05v-.383C4 .747 4.746 0 5.667 0h4.666C11.253 0 12 .746 12 1.667v.383a2.512 2.512 0 0 0-.5-.05h-7c-.171 0-.338.017-.5.05zm0 11.9c.162.033.329.05.5.05h7c.171 0 .338-.017.5-.05v.383c0 .92-.746 1.667-1.667 1.667H5.667C4.747 16 4 15.254 4 14.333v-.383z"/></svg>Horizon de temps (années)</th>
                            <th class="pb-2" scope="col" style="width: 33.3%; vertical-align: middle;"><svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-graph-up svgframe" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5z"/></svg>Niveau de risque</th>
                        </tr>
                    </thead>
                    <tbody  class="paragraphe text-center align-content-center" style="font-size: 12px; width:100%;">
                        <tr class="">
                            <td class="text-justify p-2" style="width:33.3%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"
                                    step="1"
                                    min="0"
                                    :name="amount"
                                    v-model="amount"
                                    @change="onDataChange">
                            </td>
                            <td class="text-justify p-2" style="width:33.3%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"
                                    step="1"
                                    min="0"
                                    :name="time_horizon"
                                    v-model="time_horizon"
                                    @change="onDataChange">
                            </td>
                            <td class="text-justify p-2" style="width:33.3%; vertical-align: middle;">
                                <input
                                    type="number"
                                    class="form-control"
                                    step="1"
                                    min="-10"
                                    :name="performance"
                                    v-model="performance"
                                    @change="onDataChange">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-8 mx-auto justify-content-center">
            <div class="row justify-content-center dashboardstyle">
                <canvas ref="chart"></canvas>
            </div>
        </div>
        <div class="col-8 mx-auto text-center pt-4">
            <p class="welcome-3 colortextmyfo1">Retour sur investissement après taxes et frais</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="table table-responsive text-center table-borderless" style="margin:auto;">
                    <thead class="paragraphe" style="font-size: 14px; flex: 0 0 auto; color: #3867D6;">
                        <tr style="display: table; table-layout: fixed; width:100%">
                            <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Assurance-Vie</th>
                            <th scope="col" style="vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Compte-Titres</th>
                        </tr>
                    </thead>
                    <tbody class="paragraphe text-center align-content-center" style="font-size: 12px; max-height: 600px; overflow: scroll; flex: 1 1 auto; display: block; overflow-y: auto; overflow-x: hidden;">
                        <tr style="display: table; width:100%">
                            <td class="text-center" style="vertical-align: middle;" >
                                {{new Intl.NumberFormat().format(total_AV)}} €
                            </td>
                            <td class="text-center" style="vertical-align: middle;" >
                                {{new Intl.NumberFormat().format(total_CT)}} €
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-8 mx-auto text-center pt-4">
            <p class="welcome-3 colortextmyfo1">Détails</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="text-center py-0 px-4" style="margin:auto; width:100%;">
                    <thead class="paragraphe" style="font-size: 14px; color: #3867D6; width:100%;">
                        <tr>
                            <th scope="col" style="width: 20%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);"></th>
                            <th class="p-3" scope="col" style="width: 40%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);">Assurance-Vie</th>
                            <th class="p-3" scope="col" style="width: 40%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214, 0.5);">Compte-Titres</th>
                        </tr>
                    </thead>
                    <tbody class="paragraphe text-center align-content-center" style="font-size: 12px; width:100%;">
                        <tr>
                            <td class="text-right p-3" style="width:20%;vertical-align: middle;" >
                                Total gain (avant taxes et frais) :
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle;" >
                                {{new Intl.NumberFormat().format(total_gain_AV)}} €
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle;" >
                                {{new Intl.NumberFormat().format(total_gain_CT)}} €
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right p-3" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                Total taxes :
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(total_tax_AV)}} €
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(total_tax_CT)}} €
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right p-3" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                Total frais :
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(total_fees_AV)}} €
                            </td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{new Intl.NumberFormat().format(total_fees_CT)}} €
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-8 text-center pt-4 mx-auto mb-4">
            <p class="welcome-3 colortextmyfo1">Hypothèses</p>
            <div class="row justify-content-center dashboardstyle py-2">
                <table class="table table-responsive text-center table-borderless py-0 px-4" style="margin:auto;">
                    <thead class="paragraphe" style="font-size: 14px; flex: 0 0 auto; color: #3867D6;">
                        <tr style="display: table; table-layout: fixed; width:100%">
                            <th scope="col" style="width: 20%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);"></th>
                            <th scope="col" style="width: 40%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Assurance-Vie</th>
                            <th scope="col" style="width: 40%; vertical-align: middle; border-bottom: 1px solid rgba(56, 103, 214,0.5);">Compte-Titres</th>
                        </tr>
                    </thead>
                    <tbody  class="paragraphe text-center align-content-center" style="font-size: 12px; max-height: 600px; overflow: scroll; flex: 1 1 auto; display: block; overflow-y: auto; overflow-x: hidden;">
                        <tr>
                            <td class="text-right" style="width:20%;vertical-align: middle;">Frais du contrat :</td>
                            <td class="text-center" style="width:40%;vertical-align: middle;">
                                {{fees_AV*100}} %
                            </td>
                            <td class="text-center" style="width:40%; vertical-align: middle;">
                                {{ fees_CT*100}} %
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Type de frais :</td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Frais de gestion, rétrocessions, prélèvements</td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">Transactions et frais sur support d'investissements</td>

                        </tr>
                        <tr>
                            <td class="text-right" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >Prélèvement forfaitaire unique :</td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{tax_compulsory_AV*100}} %
                            </td>
                            <td style="width:40%; vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{ tax_compulsory_CT*100}} %
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >Prélèvements sociaux :</td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{tax_social_AV*100}} %
                            </td>
                            <td class="text-center" style="width:40%; vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{ tax_social_CT*100}} %
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right" style="width:20%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >Abattement :</td>
                            <td class="text-center" style="width:40%;vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);" >
                                {{tax_abbattement_AV}} €
                            </td>
                            <td class="text-center" style="width:40%; vertical-align: middle; border-top: 1px solid rgba(56, 103, 214,0.2);">
                                {{ tax_abbattement_CT}} €
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>


</template>

<script>
    import {Chart} from 'chart.js';
    


    export default{

        data() {
            return {
                testGraph: null,
                amount: 15000,
                time_horizon: 8,
                performance: 5,
                floor_rate: 0.8,
                fees_CT: 0.01,
                fees_AV: 0.025,
                total_AV: 0,
                total_CT: 0,
                total_gain_AV: 0,
                total_gain_CT: 0,
                total_tax_AV: 0,
                total_tax_CT: 0,
                total_fees_AV: 0,
                total_fees_CT: 0,
                tax_compulsory_AV: 0.075,
                tax_compulsory_CT: 0.128,
                tax_social_AV: 0.172,
                tax_social_CT: 0.172,
                tax_abbattement_AV: 4600,
                tax_abbattement_CT: 0,
            }
        },


        mounted() {
            var ctx = this.$refs.chart.getContext('2d');
            var gradient = ctx.createLinearGradient(0, 0, 0, 400);

            gradient.addColorStop(0, 'rgba(56, 103, 214,0.3)');
            gradient.addColorStop(0.5, 'rgba(56, 103, 214,0.1)');
            gradient.addColorStop(1, 'rgba(56, 103, 214, 0)');

            this.testGraph = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Portefeuille Assurance-Vie',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .5)',
                            fontFamily: "Poppins",
                        },
                        {
                            label: 'Portefeuille Compte-Titres',
                            data: [],
                            fill: true,
                            backgroundColor: 'rgba(56, 103, 214, .8)',
                            fontFamily: "Poppins",
                        },
                    ],
                },

                options: {
                    scales: {
                        tooltips: {
                            titleFontFamily: "Poppins",
                            titleFontStyle: 'normal',
                            bodyFontFamily: 'Poppins'
                        },
                        legend: {
                            fontFamily: "Poppins"
                        },
                        yAxes:[
                            {
                                stacked: false,
                                ticks: {
                                    beginAtZero: true,
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(169,169,169)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                            }
                        ],
                        xAxes:[
                            {
                                ticks: {
                                    fontFamily: "Poppins",
                                    fontColor: 'rgb(56, 103, 214)',
                                    fontSize: 10,
                                },
                                gridLines: {
                                    offsetGridLines: true,
                                    display:false
                                },
                                stacked: false,
                            }
                        ]
                    }
                }
            });
            this.onDataChange();
        },

        methods: {
            onDataChange(){
                // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance

                var labels = [];
                var data_av = [];
                var data_ct = [];
                var fees_CT = 0.01;
                var fees_AV = 0.025;
                var total_AV = 0;
                var total_CT = 0;
                var total_gain_AV = 0;
                var total_gain_CT = 0;
                var total_tax_AV = 0;
                var total_tax_CT = 0;
                var total_fees_AV = 0;
                var total_fees_CT = 0;

                for (let year = 0; year < this.time_horizon; year++)
                {

                    labels[year] = "Année " + (parseFloat(year) +1);
                    //abbatement only for AV and after 8 years
                    // tax when closing the portfolio on AV vs every year on CT
                    if (this.time_horizon <8 ) {
                        if (year == this.time_horizon - 1 ){
                            data_av[year] = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1)) - ((this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1))-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV)));
                        }
                        else {
                            data_av[year] = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1)));
                        }
                    }
                    else{
                        if (year == this.time_horizon - 1 ){
                            data_av[year] = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1)) - Math.max(0,((this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1))-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV)-this.tax_abbattement_AV)));
                        }
                        else {
                            data_av[year] = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),year+1)));
                        }
                    }
                    data_ct[year] = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_CT),year+1)) -((this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_CT),year+1))-this.amount)*(this.tax_compulsory_CT+this.tax_social_CT)-this.tax_abbattement_CT));
                }

                if (this.time_horizon <8 ){
                    this.total_AV = Math.round(data_av.slice(-1)[0] - ((data_av.slice(-1)[0]-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV)));
                }
                else {
                    this.total_AV = Math.round(data_av.slice(-1)[0] - Math.max(0,((data_av.slice(-1)[0]-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV)-this.tax_abbattement_AV)));
                }
                this.total_CT= Math.round(data_ct.slice(-1)[0]);


                this.total_gain_AV = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100)),this.time_horizon -1)) - this.amount);
                this.total_gain_CT = Math.round(this.amount*Math.pow((1+parseFloat(this.performance/100)),this.time_horizon -1) - this.amount);

                if (this.time_horizon <8 ){
                    this.total_tax_AV = Math.round((this.amount*(Math.pow((1+parseFloat(this.performance/100)),this.time_horizon -1))-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV));
                }
                else {
                    this.total_tax_AV =  Math.max(0,((this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),this.time_horizon -1)))-this.amount)*(this.tax_compulsory_AV+this.tax_social_AV)-this.tax_abbattement_AV);
                }
                this.total_fees_AV = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100)),this.time_horizon -1)) - this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_AV),this.time_horizon -1)));

                this.total_tax_CT =  Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100)*(1-this.fees_CT)),this.time_horizon -1)) - Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_CT),this.time_horizon -1)) -((this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_CT),this.time_horizon -1))-this.amount)*(this.tax_compulsory_CT+this.tax_social_CT)-this.tax_abbattement_CT)));
                this.total_fees_CT = Math.round(this.amount*(Math.pow((1+parseFloat(this.performance/100)),this.time_horizon -1)) - this.amount*(Math.pow((1+parseFloat(this.performance/100))*(1-this.fees_CT),this.time_horizon -1)));


                this.testGraph.data.labels = labels;
                this.testGraph.data.datasets[0].data = data_av;
                this.testGraph.data.datasets[1].data = data_ct;
                this.testGraph.update();
            },
        }
    }

</script>
